import React from "react";
import D01 from "./D01";
export default function FaqMain({ data }) {
  return (
    <div>
      {data?.advanceData?.design === "D01" ? (
        <D01 faqItem={data}></D01>
      ) : (
        <D01 faqItem={data}></D01>
      )}
    </div>
  );
}
